<template>
  <div class="trend-wrapper">
    <div class="forecast">
      <slot name="title" :dropPrice="dropPrice">
        预计下月再跌<span> ↓ {{ dropPrice }}</span> 元，与其闲置，不如换钱买买买
      </slot>
    </div>
    <div class="chart-hd">
      <div class="hsb-price" :style="{color: hsbColor}">{{hsbLabel}}</div>
      <div class="market-price" :style="{color: otherColor}">{{otherLabel}}</div>
    </div>
    <div class="chart-wrapper" ref="priceChart">
      <div class="chart-loading">
        <span>loading</span>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">

import { getProductPriceTrend } from '@/apis/base';

var historyTime = [];
var historyPrice = [];
var marketPrice = [];

function getOption (hsbColor, marketColor, moneyFormatter, monthFormatter) {
  historyTime.shift();
  historyPrice.shift();
  var historyMaxPrice = Math.max.apply(null, historyPrice) + 100;
  var historyMinPrice = Math.max((Math.min.apply(null, historyPrice) - 100), 0);
  marketPrice = historyPrice.map(function (value, index) {
    switch (index) {
      case 0:
        return value * (1 - 0.03);
      case 1:
        return value * (1 - 0.02);
      case 2:
        return value * (1 - 0.03);
      case 3:
        return value * (1 - 0.05);
      case 4:
        return value * (1 - 0.03);
      default:
        return value * (1 - 0.06);
    }
  });
  var option = {
    grid: {
      show: true,
      left: '50',
      top: '20',
      right: '22',
      bottom: '20%',
      borderColor: '#ffffff'
    },
    xAxis: {
      type: 'category',
      axisTick: {
        show: true
      },
      splitLine: {
        show: true,
        interval: 0,
        lineStyle: {
          color: ['#e3e3e3']
        }
      },
      axisLabel: {
        textStyle: {
          color: '#666',
          fontSize: 12
        },
        formatter: monthFormatter
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#e3e3e3'
        }
      },
      data: historyTime
    },
    yAxis: {
      type: 'value',
      scale: true,
      axisTick: {
        show: false
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#e3e3e3'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ['#e3e3e3']
        }
      },
      interval: parseInt((historyMaxPrice - historyMinPrice) / 4),
      min: historyMinPrice,
      max: historyMaxPrice,
      axisLabel: {
        formatter: moneyFormatter,
        textStyle: {
          color: '#666',
          fontSize: 12
        }
      }
    },
    series: [
      {
        name: '回收价',
        type: 'line',
        label: {
          normal: {
            show: true,
            textStyle: {
              color: hsbColor,
              fontSize: 12
            }
          }
        },
        data: historyPrice,
        symbol: 'circle',
        symbolSize: 8,
        itemStyle: {
          normal: {
            color: hsbColor
          }
        },
        lineStyle: {
          normal: {
            width: 2
          }
        }
      },
      {
        name: '市场均价',
        type: 'line',
        label: {
          normal: {
            show: false,
            textStyle: {
              color: '#999',
              fontSize: 14
            }
          }
        },
        data: marketPrice,
        symbol: 'circle',
        symbolSize: 8,
        itemStyle: {
          normal: {
            color: marketColor
          }
        },
        lineStyle: {
          normal: {
            width: 2
          }
        }
      }

    ]
  };
  return option;
}

export default {
  props: {
    evaInfo: {
      type: Object
    },
    hsbColor: {
      type: String,
      default: '#3b9bff'
    },
    otherColor: {
      type: String,
      default: '#f7b448'
    },
    hsbLabel: {
      type: String,
      default: '分期乐报价'
    },
    otherLabel: {
      type: String,
      default: '市场均价'
    },
    moneyFormatter: {
      type: Function,
      default: function (value) {
        return `￥${value}`;
      }
    },
    monthFormatter: {
      type: Function,
      default: function (value) {
        return value + '月';
      }
    }
  },
  data () {
    return {
      months: [],
      prices: [],
      dropPrice: 0
    };
  },
  methods: {
    async getData () {
      const evaInfo = this.evaInfo;
      try {
        let ret = await getProductPriceTrend(evaInfo.productId, evaInfo.quotation);
        if (ret._errCode === '0') {
          this.months = historyTime = ret._data.months;
          this.prices = historyPrice = ret._data.prices;
          const len = historyPrice.length;
          this.dropPrice = parseInt((historyPrice[len - 2] - historyPrice[len - 1]) / 100);
          let newHistoryPrice = historyPrice.map(item => {
            return Math.round(item / 100);
          });
          historyPrice = newHistoryPrice;
          let option = getOption(this.hsbColor, this.otherColor, this.moneyFormatter, this.monthFormatter);
          import('echarts').then(echarts => {
            if (!this.$refs.priceChart) {
              return;
            }
            var myChart = echarts.init(this.$refs.priceChart);
            myChart.setOption(option);
            window.addEventListener('resize', function () {
              myChart.resize();
            });
          }, error => {
            console.log(error);
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    init () {
      if (this.evaInfo && this.evaInfo.productId) {
        this.getData();
      } else {
        const unWatch = this.$watch('evaInfo', (val) => {
          if (!val) return false;
          this.getData();
          unWatch();
        });
      }
    }
  },
  mounted () {
    this.init();
  }
};
</script>

<style lang="css" scoped>

.trend-wrapper {
  position: relative;
}

/* 下跌预测 */
.forecast {
  position: relative;
  height: 42px;
  line-height: 42px;
  text-align: center;
  &::after, &::before {
    content: " ";
    position: absolute;
    left: 0;
    display: block;
    height: 1PX;
    width: 100%;
    background-color: #F5F5F5;
  }
  &::after {
    top: 0;
  }
  &::before {
    bottom: 0;
  }
}

.chart-wrapper {
  margin: 0 15px;
  height: 200px;
}

.chart-hd {
  display: flex;
  height: 46px;
  margin-top: 6px;
  line-height: 46px;
  justify-content: center;
  width: 100%;
  & > div {
    margin: 0 20px;
  }
}

.hsb-price, .market-price {
  position: relative;
  &::after, &::before {
    content: "";
    position: absolute;
    top: 8px;
    left: 50%;
    display: block;
    width: 30px;
    height: 1px;
    background-color: #3b9bff;
    transform: translate(-50%, -50%);
  },
  &::before {
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background-color: #3b9bff;
  }
}

.hsb-price {
  color: #3b9bff;
  &::after {
    background-color: #3b9bff;
  }
}

.market-price {
  color: #f7b448;
  &::after, &::before {
    background-color: #f7b448;
  }
}

.chart-loading {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/core/common-ui/price-trend/price-trend.vue